const axios = require("axios");
module.exports.init = me => {
  //Collections

  me.getCollectionTree = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/collections/tree`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.getPrivateCollections = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/online-library/collections/search`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.getCollection = (collection_id, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/collections/search`, {
      collection_id
    }, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      on_success(response.data.data.data[0]);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.createCollection = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/online-library/collections/create`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.editCollection = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/online-library/collections/edit/${data.collection_id}`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.removeCollection = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/online-library/collections/remove/${data.collection_id}`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.recycleCollection = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/online-library/collections/recycle/${data.collection_id}`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  //End of Collections

  me.getDocuments = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/online-library/documents/search`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.createDocument = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/online-library/documents/create`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.getDocument = (document_id, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/documents/search`, {
      document_id
    }, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data.data[0]);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.editDocument = (document_id, data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/documents/edit/${document_id}`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.deleteDocument = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/documents/remove/${data.document_id}`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.recycleDocument = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/documents/recycle/${data.document_id}`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.copyDocument = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/documents/copy`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.mergeDocument = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/documents/merge`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  //endDocument

  //permissions 
  me.searchPermission = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/permissions/search`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.editPermission = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/permissions/edit/${data.permission_id}`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  //end permission
  //history 
  me.getDocumentHistory = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/histories/documents`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };

  //end history
  //favorites
  me.createFavorite = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/favorites/create`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.editFavorite = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/favorites/edit/${data.favorite_id}`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.deleteFavorite = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/favorites/remove/${data.favorite_id}`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.searchFavorite = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/favorites/search`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };

  // end favorites
  //notes
  me.createNote = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/notes/create`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.editNote = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/notes/edit/${data.note_id}`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.deleteNote = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/notes/remove/${data.comment_id}`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.searchNote = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/notes/search`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };

  //end notes
  //citeproc
  me.generateCitations = (data, on_success, on_failure) => {
    axios.post(`${me.config.url}/online-library/citations`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  //end cite proc
};